import React, { Component }  from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import '../CardsConselheiros/CardsConselheiros.css';
import marcelo from '../../img/marcelo.png'
import gustavo from '../../img/gustavo.png'
import gobbo from '../../img/gobbo2.jpg'
import emerson from '../../img/emerson5.jpeg'
import mariaaparecida from '../../img/mariaaparecida.jpg'

// const cardsData = [
//   {
//     image: marcelo,
//     title: 'Dr. Marcelo Sinício',
//     subtext: 'Pediatra',
//     text: 'Presidente do Conselho', 
//   },
  const cardsData = [
  {
    image: emerson,
    title: 'Dr. Emerson Nunes',
    subtext: 'Nefrologista',
    text: 'Presidente do Conselho', 
  },
  // {
  //   image: gustavo,
  //   title: 'Dr. Gustavo Brandão',
  //   subtext: 'Ortopedista e Traumatologista',
  //   text: 'Membro do Conselho',
  // }, 
  {
    image: mariaaparecida,
    title: 'Dra. Maria Aparecida',
    subtext: 'Cirurgiã Plástica',
    text: 'Membro do Conselho',
  },
  {
    image: gobbo,
    title: 'Dr. Marcelo Gobbo',
    subtext:  'Médico de Família',
    text: 'Membro do Conselho',
  },
];


function Cards() {
  return (
    <Row xs={1} md={3} className="cardsConselheiros">
      {cardsData.map((card, idx) => (
        <Col key={idx} style={{ marginBottom: '20px' }}>
          <Card style={{ height: '100%' }} id='cardConselheiros'>
          <Card.Img
              variant="top"
              src={card.image}
              style={{ width: '100%', height: '320px', objectFit: 'cover', objectPosition: 'top' }}
            />
            <Card.Body style={{ display: 'flex', flexDirection: 'column'}}>
              <Card.Title style={{ fontSize: '1.5rem', fontWeight: 'bold', color:'#3E554F'}}>{card.title}</Card.Title> 
              <Card.Text style={{ fontSize: '1rem', color:'#848D8B', marginBottom:'-5px' }}>{card.subtext}</Card.Text>
              <Card.Text style={{ fontSize: '1rem', color:'#848D8B', marginBottom:'10px' }}>{card.text}</Card.Text> 
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default Cards;